import api from './api-inteceptor';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const API_URL = {
  createItem: '/api/items/create',
  createClient: '/api/clients/create',
  getItems: '/api/items/list',
  getCategories: '/api/categories/list',
  createCategory: '/api/categories/create',
  deleteItem: '/api/items/delete',
  getClients: '/api/clients/list',
  getInvoices: '/api/invoices/list',
  searchItem: '/api/items/search',
  getOrderList: '/api/orders/list',
  getOrderListCount: '/api/orders/count-list',
  getPurchaseOrderList: '/api/purchaseorders/list',
  getPaymentList: '/api/payments/list',
  login: '/api/users/login',
  signin: '/api/users/signup',
  updateUser: '/api/users/update',
  createAgreement: '/api/agreements/create',
  getBranchList: '/api/branch/list',
  getClientBranchList: '/api/branch/list-client',
  getBranchById: '/api/branch',
  createBranch: '/api/branch/create',
  createBulkBranch: '/api/branch/bulk-create',
  updateBranch: '/api/branch/update',
  getWarehouseList: '/api/warehouses/list',
  getUserList: '/api/users/get/users',
  getUserRole: '/api/roles/list',
  getItemData: '/api/items/get',
  getInvoiceDetails: '/api/invoices/id/',
  getPaymentDetails: '/api/payments/id',
  getInvoice: '/api/invoices/id/',
  getOrderDetails: '/api/orders/id',
  getOrderDocuments:'/api/orders',
  getAgreement: '/api/agreements/agreement',
  getAgreementsList: '/api/agreements/list',
  editItem: '/api/items/update',
  getTaxes: '/api/taxes/list',
  getClientWithId: '/api/clients/get',
  getEstimateList: '/api/estimates/list',
  getExpenses: '/api/expenses/list',
  getEstimate: '/api/estimates/id/',
  getAgreementItems: '/api/items/agreement-item-list',
  getClientUsers: '/api/users/get/client-users',
  getUserById: '/api/users/get/user',
  updateUserStatus: '/api/users/status',
  updateItemStatus: '/api/items/update-status',
  createPurchaseOrder: '/api/purchaseorders/create',
  updatePurchaseOrder: '/api/purchaseorders/update',
  getPurchaseOrderDetails: '/api/purchaseorders',
  purchaseOrderStatusChange: '/api/purchaseorders/status',
  convertToSalesOrder: '/api/orders/convert-to-sales-order',
  getUserProfile: '/api/users/profile',
  getPurchaseOrderStatusList: '/api/purchaseorders/list/status',
  updateClient: '/api/clients/update',
  getPurchaseOrderSequence: '/api/purchaseorders/sequence',
  createPurchaseRequisition: '/api/purchaserequisition/create',
  updatePurchaseRequisition: '/api/purchaserequisition/update',
  updatePurchaseRequisitionStatus: '/api/purchaserequisition/status',
  getPurchaseRequisitionList: '/api/purchaserequisition/list',
  getPurchaseRequisition: '/api/purchaserequisition',
  getPurchaseRequisitionSequence: '/api/purchaserequisition/sequence',
  convertPRToPO: '/api/purchaserequisition/convert-to-purchase-order',
  forgotPassword: '/api/users/forgot-password',
  resetPassword: '/api/users/reset-password',
  updateUserActivation: '/api/users/update-status',
  updateClientStatus: '/api/clients/update-status',
  getUserStatus: '/api/users/get-status',
  uploadCSV: 'api/upload/csv',
  uploadAgreement: 'api/file/upload',
  viewFile: 'api/file/upload-url',
  createEditTaxIdentity: '/api/taxidentity/create-edit',
  deleteTaxIdentity: '/api/taxidentity/delete',
  createBudget: '/api/budget/create',
  getBudgets: '/api/budget/list',
  updateBudget: '/api/budget/update',
  deleteBudget: '/api/budget/delete',
  getModuleList: '/api/roles/list/module',
  createRole: '/api/roles/create',
  updateRole: '/api/roles/update',
  getDashboardData: '/api/reports/dashboard',
  getPRList: '/api/reports/pr/list',
  getPOList: '/api/reports/po/list',
  getItemPRList: '/api/reports/item/pr/list',
  getItemPOList: '/api/reports/item/po/list',
  getGraphCategories: '/api/reports/po/category/list',
  getPrFavoritesList: '/api/purchaserequisition/favourite/list',
  addToFavourite: '/api/purchaserequisition/favourite/add',
  removeFromFavourite: '/api/purchaserequisition/favourite/remove',
};

export { API_URL, baseUrl };


export async function createItem(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.createItem}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function updateItemStatus(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.updateItemStatus}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function updateClientStatus(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.updateClientStatus}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => reject(error));
  });
}

export async function createClient(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.createClient}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => reject(error));
  });
}

export async function updateClient(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.updateClient}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => reject(error));
  });
}

export async function createAgreement(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.createAgreement}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => reject(error));
  });
}

export async function getItems(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getItems}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getClientWithId(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.getClientWithId}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error.response);
      });
  });
}

export async function getAgreement(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.getAgreement}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
}

export async function getAgreementsList(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.getAgreementsList}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getTaxes() {
  return new Promise((resolve, reject) => {
    api
      .get(`${API_URL.getTaxes}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error.response.status);
      });
  });
}

export async function editItem(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.editItem}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error.response.status);
      });
  });
}

export async function getUserList(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getUserList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getClientUsers(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getClientUsers}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getUserById(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getUserById}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getUserRole(isAdmin) {
  let url;
  if (isAdmin) {
    url = `${API_URL.getUserRole}/admin`;
  } else {
    url = `${API_URL.getUserRole}`;
  }
  return new Promise((resolve) => {
    api.get(url).then((res) => {
      resolve(res.data);
      return res.data;
    });
  });
}

export async function getBranchList(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getBranchList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getClientBranchList() {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getClientBranchList}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPurchaseOrderList(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getPurchaseOrderList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPurchaseOrderDetails(id, body) {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getPurchaseOrderDetails}/${id}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPurchaseOrderAudit(id, body) {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getPurchaseOrderDetails}/${id}/audit`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPurchaseOrderAuditDetails(id, auditId, body) {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getPurchaseOrderDetails}/${id}/audit/${auditId}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function createPurchaseOrder(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.createPurchaseOrder}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function updatePurchaseOrder(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.updatePurchaseOrder}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function purchaseOrderStatusChange(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.purchaseOrderStatusChange}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function convertToSalesOrder(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.convertToSalesOrder}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getBranchById(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getBranchById}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function updateBranch(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.updateBranch}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function updateUser(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.updateUser}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getWarehouseList(body) {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getWarehouseList}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function createBranch(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.createBranch}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function createBulkBranch(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.createBulkBranch}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getItemData(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getItemData}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getInvoices(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.getInvoices}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  }).catch((error) => {
    console.log(error);
    return error?.response;
  });
}

export async function getEstimates(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.getEstimateList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  }).catch((error) => {
    console.log(error);
    return error?.response;
  });
}

export async function getExpenses(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.getExpenses}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  }).catch((error) => {
    console.log(error);
    return error?.response;
  });
}

export async function getPaymentDetails(id, body) {
  return new Promise((resolve, reject) => {
    api
      .get(`${API_URL.getPaymentDetails}/${id}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  }).catch((error) => {
    console.log(error);
    return error?.response;
  });
}

export async function getOrderDetails(id, body) {
  return new Promise((resolve, reject) => {
    api
      .get(`${API_URL.getOrderDetails}/${id}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  }).catch((error) => {
    console.log(error);
    return error?.response;
  });
}
export async function getOrderDocuments(orderId, documentId) {
  try {
    const res = await api.get(
      `${API_URL.getOrderDocuments}/${orderId}/documents/${documentId}`,
      {
        responseType: "blob",
      }
    );

    return res.data;
  } catch (error) {
    console.log(error);
    return error?.response;
  }
}


export async function getPaymentList(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.getPaymentList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  }).catch((error) => {
    console.log(error);
    return error?.response;
  });
}

export async function getClients(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getClients}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getCategories(body) {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getCategories}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function createCategory(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.createCategory}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  }).catch((error) => {
    console.log(error);
    return error.response.data;
  });
}
export async function deleteItem(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.deleteItem}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  }).catch((error) => {
    console.log(error);
    return error.response.data;
  });
}

export async function searchItem(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.searchItem}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getOrderList(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.getOrderList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getOrderListCount(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.getOrderListCount}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function login(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.login}`, body, { withCredentials: true })
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        console.log(error);
        resolve(error.response.data);
      });
  });
}

export async function forgotPassword(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.forgotPassword}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        console.log(error);
        resolve(error.response.data);
      });
  });
}

export async function resetPassword(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.resetPassword}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        console.log(error);
        reject(error.response.data);
      });
  });
}

export async function getInvoice(body, id) {
  return new Promise((resolve, reject) => {
    api
      .get(`${API_URL.getInvoice + id}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        console.log(error);
        resolve(error.response.data);
      });
  });
}

export async function getEstimate(body, id) {
  return new Promise((resolve, reject) => {
    api
      .get(`${API_URL.getEstimate + id}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        console.log(error);
        resolve(error.response.data);
      });
  });
}

export async function signin(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.signin}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  }).catch((error) => {
    console.log(error);
    return error.response.data;
  });
}

export async function getAgreementItems(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getAgreementItems}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getUploadUrl() {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getUploadUrl}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getUserProfile() {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getUserProfile}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPurchaseOrderStatusList() {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getPurchaseOrderStatusList}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPurchaseOrderSequence() {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getPurchaseOrderSequence}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function updateUserStatus(body) {
  try {
    const response = await api.post(
      `${API_URL.updateUserActivation}`,
      body);
    return response.data;
  } catch (error) {
    console.log(error);
    return (
      error.response?.data || {
        success: false,
        message: 'Something went wrong',
      }
    );
  }
}

export async function getUserStatus() {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getUserStatus}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function handleClientDeactivation(body) {
  try {
    const response = await api.post(
      `${API_URL.updateClientStatus}`,
      body);
    return response.data;
  } catch (error) {
    console.log(error);
    return (
      error.response?.data || {
        success: false,
        message: 'Something went wrong',
      }
    );
  }
}

export async function getPurchaseRequisitionList(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getPurchaseRequisitionList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        console.log(error);
        return error.response.data;
      });
  });
}

export async function getPurchaseRequisitionDetails(id) {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getPurchaseRequisition}/${id}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        console.log(error);
        return error.response.data;
      });
  });
}

export async function getPurchaseRequisitionAudit(id) {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getPurchaseRequisition}/${id}/audit`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPurchaseRequisitionAuditDetails(id, auditId) {
  return new Promise((resolve) => {
    api
      .get(
        `${API_URL.getPurchaseRequisition}/${id}/audit/${auditId}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPurchaseRequisitionSequence() {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getPurchaseRequisitionSequence}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        console.log(error);
        return error.response.data;
      });
  });
}

export async function createPurchaseRequisition(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.createPurchaseRequisition}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function updatePurchaseRequisition(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.updatePurchaseRequisition}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function updatePurchaseRequisitionStatus(body) {
  return new Promise((resolve, reject) => {
    api
      .post(`${API_URL.updatePurchaseRequisitionStatus}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function convertPRToPO(prId) {
  return new Promise((resolve, reject) => {
    api
      .post(
        `${API_URL.convertPRToPO}`,
        { purchaseRequisitionId: prId })
      .then((res) => {
        resolve(res.data);
        return res.data;
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function createEditTaxIdentity(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.createEditTaxIdentity}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function deleteTaxIdentity(id) {
  return new Promise((resolve) => {
    api
      .delete(`${API_URL.deleteTaxIdentity}/${id}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function createBudget(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.createBudget}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getBudgets(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getBudgets}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function updateBudget(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.updateBudget}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}
export async function deleteBudget(id) {
  return new Promise((resolve) => {
    api
      .delete(`${API_URL.deleteBudget}/${id}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getModuleList() {
  return new Promise((resolve) => {
    api
      .get(`${API_URL.getModuleList}`)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function createRole(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.createRole}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function UpdateRole(id, body) {
  return new Promise((resolve) => {
    api
      .put(`${API_URL.updateRole}/${id}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getDashboardData(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getDashboardData}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPRList(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getPRList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPOList(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getPOList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getItemPRList(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getItemPRList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getItemPOList(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getItemPOList}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getGraphCategories(body) {
  return new Promise((resolve) => {
    api
      .post(`${API_URL.getGraphCategories}`, body)
      .then((res) => {
        resolve(res.data);
        return res.data;
      });
  });
}

export async function getPrFavoritesList(body) {
  return new Promise((resolve, reject) => {
    api
      .get(`${API_URL.getPrFavoritesList}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export async function addToFavourite(id) {
  return new Promise((resolve, reject) => {
    api
      .get(`${API_URL.addToFavourite}/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export async function removeFromFavourite(id) {
  return new Promise((resolve, reject) => {
    api
      .get(`${API_URL.removeFromFavourite}/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export async function getAgreementDocument(id) {
  return new Promise((resolve, reject) => {
    api.get(`${API_URL.viewFile}/agreements/${id}`)
      .then((res) => {
        resolve(res);
        return res;
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export async function uploadFile(uploadType, formData) {
  let url;
  switch(uploadType) {
		case 'agreement':
		  url = API_URL.uploadAgreement;
			break;
		case 'items':
			default: url = API_URL.uploadCSV;
	}

  return new Promise((resolve, reject) => {
    api.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
		}).then((res) => {
        resolve(res);
        return res;
      })
      .catch((err) => {
        reject(err);
      });
  });
}